import { graphQlClient } from '@config/graphqlClient';
import MerchantPaymentAccountGraphQL from '@graphql/merchantPaymentAccount.queries';
import { MerchantPaymentAccount } from '@models/merchantPaymentAccount.model';

export const merchantPaymentAccountService = {
  async getMyPaymentAccount(): Promise<MerchantPaymentAccount | null> {
    const data: any = await graphQlClient.request(
      MerchantPaymentAccountGraphQL.queries.myPaymentAccount,
    );
    return data?.myPaymentAccount ?? null;
  },

  async connectNmiAccount(securityKey: string): Promise<MerchantPaymentAccount> {
    const data: any = await graphQlClient.request(
      MerchantPaymentAccountGraphQL.mutations.connectNmiAccount,
      { input: { securityKey } },
    );
    return data?.connectNmiAccount;
  },

  async disconnectNmiAccount(): Promise<boolean> {
    const data: any = await graphQlClient.request(
      MerchantPaymentAccountGraphQL.mutations.disconnectNmiAccount,
    );
    return data?.disconnectNmiAccount ?? false;
  },
};
